import React from "react";
import PropTypes from "prop-types";
import Modal from "../../../../../../../shared/components/redesigned/Modal";
import htmlUtils from "../../../../../../../utils/htmlUtils";

const AssignedAccountDetailModal = ({ hideModal, account }) => (
    <Modal isOpen onClose={hideModal} title={account.name} width="max-w-2xl">
        <div
            className="text-sm text-ink"
            dangerouslySetInnerHTML={{ __html: htmlUtils.sanitize(account.wiki) }}
        />
    </Modal>
);

AssignedAccountDetailModal.propTypes = {
    account: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        expertUrl: PropTypes.string,
        code: PropTypes.string,
        contractState: PropTypes.string,
        ico: PropTypes.string,
        vatin: PropTypes.string,
        wiki: PropTypes.string,
    }).isRequired,
    hideModal: PropTypes.func.isRequired,
};

export default AssignedAccountDetailModal;
